import { pluralRu } from '../../plural';

const playersCount = (n: number): string => `${n} ${pluralRu(n, 'игрок', 'игрока', 'игроков')}`;

export const matches = {
  list: {
    title: 'Матчи',
    searchPlaceholder: 'Имя игрока или ID матча',
    playerSearchError: 'Не удалось выполнить поиск игроков.',
    loadError: 'Не удалось загрузить матчи.',
    hoursMinutes: (hours: number, minutes: number): string => `${hours}ч ${minutes}м`,
    minutes: (minutes: number): string => `${minutes}м`,
    live: 'идёт',
    sort: {
      newest: 'Новые',
      oldest: 'Старые',
      mostRounds: 'Больше раундов',
      fewestRounds: 'Меньше раундов'
    },
    sortLabel: 'Сортировка',
    sortOption: (label: string): string => `Сорт: ${label}`,
    rosterLabel: 'Состав матча',
    playersCount,
    statusEnded: 'Завершён',
    statusLive: 'В игре',
    heroOfPlayer: (nick: string): string => `Герой · ${nick}`,
    filters: {
      statusAll: 'Статус: Все',
      statusEnded: 'Завершённые',
      statusActive: 'Активные',
      typeAll: 'Тип: Все',
      startAll: 'Старт: Всё время',
      today: 'Сегодня',
      days7: 'За 7 дней',
      days30: 'За 30 дней'
    },
    clearPlayerFilter: 'Сбросить фильтр по игроку',
    playerChip: (name: string): string => `Игрок: ${name}`,
    chips: {
      active: 'Активные',
      endedToday: 'Завершённые сегодня',
      withMe: 'С твоим участием'
    },
    resetFilters: 'Сбросить фильтры',
    newMatches: (n: number): string =>
      `${n} ${pluralRu(n, 'новый матч', 'новых матча', 'новых матчей')} · обновить`,
    columns: {
      type: 'Тип',
      startDuration: 'Старт · Длит.',
      myHero: 'Твой герой',
      playerHero: 'Герой игрока',
      players: 'Игроки',
      winner: 'Победитель',
      round: 'Раунд',
      status: 'Статус'
    },
    loadingLabel: 'Загрузка матчей',
    emptyTitle: 'Матчи не найдены',
    emptyHint: 'Попробуйте изменить фильтры',
    openMatch: (id: string): string => `Открыть матч ${id}`,
    pageInfo: (page: number, totalPages: number, total: number): string =>
      `Стр. ${page} / ${totalPages} · всего ${total}`,
    prev: '← Назад',
    next: 'Вперёд →'
  },
  mine: {
    loadError: 'Не удалось загрузить ваши матчи.',
    kicker: 'Личное',
    title: 'Мои матчи',
    total: (n: number): string => `${n} всего`
  },
  detail: {
    loadError: 'Не удалось загрузить матч.',
    stateLoadError: 'Не удалось загрузить состояние матча.',
    hoursMinutes: (hours: number, minutes: number): string => `${hours}ч ${minutes}м`,
    minutes: (minutes: number): string => `${minutes}м`,
    playersCount,
    loadingMatch: 'Загружаю матч...',
    notFoundTitle: 'Матч не найден',
    notFoundDescription: 'Матч с таким идентификатором не существует.',
    toMatchList: 'К списку матчей',
    backToFeed: '← К ленте матчей',
    statusEnded: 'Завершён',
    statusLive: 'В игре',
    matchEnded: 'Матч завершён',
    sendCommandTitle: 'Отправить команду в матч',
    command: 'Команда',
    copyId: 'Скопировать ID',
    copyMatchId: 'Скопировать ID матча',
    kpi: {
      start: 'Старт',
      end: 'Конец',
      duration: 'Длительность',
      round: 'Раунд',
      place: 'Место',
      hero: 'Герой',
      rating: 'Рейтинг',
      duelsWl: 'Дуэли W/L',
      eliminatedRound: 'Вылет в раунде'
    },
    yourResult: 'Твой результат',
    bansHeroes: 'Герои',
    bansAbilities: 'Способности',
    loadingBans: 'Загружаю баны...',
    playersPanelTitle: 'Игроки и места',
    playersPanelSub: (n: number): string => `${n} участников · в порядке текущего места`,
    stateErrorTitle: 'Ошибка состояния',
    noPlayers: 'Нет игроков',
    chat: {
      title: 'Чат матча',
      loading: 'Загружаю чат...',
      errorTitle: 'Ошибка чата',
      loadError: 'Не удалось загрузить чат матча.',
      empty: 'Сообщений нет',
      teamTag: 'Команда',
      ariaLabel: 'Сообщения чата матча',
      round: (round: number): string => `Р${round}`
    }
  },
  bansStrip: {
    heroes: 'Баны героев',
    abilities: 'Баны абилок'
  },
  commandModal: {
    choose: '— выберите —',
    choosePlayer: '— выберите игрока —',
    playerUid: 'UID игрока',
    catalogLoadError: 'Не удалось загрузить каталог команд.',
    chooseType: 'Выберите тип команды.',
    fieldRequired: (label: string): string => `Поле «${label}» обязательно для заполнения.`,
    sent: 'Команда отправлена.',
    sendError: 'Не удалось отправить команду.',
    ariaLabel: 'Отправить команду матча',
    kicker: 'АДМИНИСТРАТОР',
    title: (matchId?: string): string => `Команда в матч${matchId ? ` · ${matchId}` : ''}`,
    loadingCatalog: 'Загружаю каталог команд…',
    commandType: 'Тип команды',
    chooseCommand: '— выберите команду —',
    catalogEmpty: 'Каталог команд пуст.',
    sending: 'Отправляю…',
    send: 'Отправить'
  },
  detailHeader: {
    kicker: 'Матч',
    statusEnded: 'Завершён',
    statusActive: 'Активен',
    stats: {
      type: 'Тип',
      round: 'Раунд',
      players: 'Игроков',
      start: 'Старт',
      finish: 'Финиш',
      duration: 'Длительность'
    },
    message: 'Сообщение',
    toList: 'К списку матчей'
  },
  table: {
    columns: {
      type: 'Тип',
      status: 'Статус',
      roster: 'Состав',
      start: 'Старт',
      finish: 'Финиш'
    },
    loading: 'Загружаю матчи…',
    empty: 'Матчи по текущим фильтрам не найдены.',
    openMatch: (id: string): string => `Открыть матч ${id}`,
    playersCount: (n: number): string => `${n} игроков`,
    statusEnded: 'Завершен',
    statusActive: 'Активен',
    next: 'Дальше',
    pageInfo: (page: number, totalPages: number, remaining: number, total: number): string =>
      `Страница ${page} / ${totalPages}, осталось ${remaining}, всего ${total}`
  },
  filters: {
    title: 'Матчи',
    total: (n: number): string => `${n} всего`,
    allStatuses: 'Все статусы',
    active: 'Активные',
    ended: 'Завершённые',
    start: 'Старт',
    finish: 'Финиш',
    startFrom: 'Старт с',
    startTo: 'Старт до',
    finishFrom: 'Финиш с',
    finishTo: 'Финиш до'
  },
  playersTable: {
    stash: 'Тайник',
    extraStash: 'Доп. тайник',
    loading: 'Загружаю состояние матча…',
    noPlayers: 'У матча пока нет игроков.',
    players: 'Игроки',
    stateNotSaved: 'Состояние матча не сохранено',
    hideStash: 'Скрыть тайники',
    showStash: 'Показать тайники',
    columns: {
      place: 'Место',
      player: 'Игрок',
      level: 'Уровень',
      gold: 'Голд',
      duel: 'Дуэль',
      hero: 'Герой',
      abilities: 'Способности',
      inventory: 'Инвентарь'
    }
  },
  stateCard: {
    ratingDelta: 'Изменение рейтинга за матч',
    profileTitle: (name: string): string => `Профиль: ${name}`,
    profileAria: (name: string): string => `Профиль игрока ${name}`,
    level: (level: number | string): string => `· ур. ${level}`,
    zones: {
      abilities: 'способности',
      items: 'предметы',
      backpack: 'рюкзак',
      stash: 'тайник',
      extraStash: 'доп. тайник'
    },
    goldTitle: 'Золото',
    gold: 'золото',
    duelScore: 'Счёт по дуэлям (побед : поражений)'
  },
  selectedPanel: {
    place: (place: number): string => `Место ${place}`,
    kicker: 'Контекст',
    title: 'Выбранный матч',
    statusEnded: 'Завершен',
    statusActive: 'Активен',
    type: 'Тип',
    players: 'Игроки',
    start: 'Старт',
    finish: 'Финиш',
    roster: 'Состав',
    playersCount: (n: number): string => `${n} игроков`,
    matchState: 'Состояние матча',
    sendMessage: 'Отправить сообщение',
    failedPrefix: 'Не удалось',
    empty: 'Выберите матч в таблице, чтобы открыть контекст.'
  }
};
